module.exports = __webpack_public_path__ + "839f241772b423d4cd52a1ae76fdfeb2.MP3";